// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__2iLRC","btn-primary":"Button_btn-primary__47DAa","btn-default":"Button_btn-default__2RgHD"};